import { FunctionComponent, useEffect, useState } from "react";
import { CorpoTable, Tabela, TabelaCabeca, TabelaCorpo, Tabler } from "../../../../../components/formulario/tableStyled";
import ServicesLideres from "../services/services";
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { Box, Button, Drawer } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";


const AddLideres: FunctionComponent = () => {

  const { coordenadores, handleIncluirLiderInCelula } = ServicesLideres()

  const nav = useNavigate();

  const { id: idPg } = useParams();

  const onClose = () => {
    setOpen(false);
    setTimeout(() => {
      nav(-1)
    }, 250);
  }

  const [open, setOpen] = useState<boolean>(false);

  const Td = () => (<>
    {
      coordenadores?.map(
        el => <tr>
          {
            ['nome_usuario', 'nome_sede_celula', 'nome_ministerio_celula']?.map(
              nome => <td>{el?.[nome]}</td>
            )
          }
          <td>
            <Button variant="contained" sx={{ boxShadow: 'none' }} onClick={() => handleIncluirLiderInCelula( el, +idPg )}>
              <AddCircleRoundedIcon />
            </Button>
          </td>
        </tr>)
    }
  </>)

  useEffect(() => {
    setOpen(true)
  }, [])

  return (<>
    <Drawer
      open={open}
      onClose={onClose}
    >
      <Box sx={{
        height: '100%',
        p: 1,
        background: 'white'
      }}>
        <div style={{ display: 'flex', gap: '8px', marginBottom: '8px', alignItems: 'center' }}>
          <Button variant="contained" onClick={() => nav(-1)}>Voltar</Button>
          <p style={{ fontSize: '18px', fontWeight: 600 }}>Lista de Coordenadores</p>
        </div>
        <div style={{ position: 'relative', height: '90%' }}>
          <Tabler>
            <CorpoTable>

              <Tabela>
                <>
                  <TabelaCabeca>
                    <tr>
                      {
                        ['Nome', 'Sede', 'Ministério']?.map(el => <th>{el}</th>)
                      }
                      <th>
                      </th>
                    </tr>
                  </TabelaCabeca>
                  <TabelaCorpo >
                    <Td />
                  </TabelaCorpo>
                </>
              </Tabela>
            </CorpoTable>
          </Tabler>

        </div>
      </Box>
    </Drawer>
  </>);
}

export default AddLideres;
